import { render } from "./SoftSkillsDynamics.vue?vue&type=template&id=daa07f8e&scoped=true"
import script from "./SoftSkillsDynamics.vue?vue&type=script&lang=js"
export * from "./SoftSkillsDynamics.vue?vue&type=script&lang=js"

import "./SoftSkillsDynamics.vue?vue&type=style&index=0&id=daa07f8e&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa07f8e"]])

export default __exports__